module.exports = __webpack_public_path__ + "7682d6e40b23dc05b30dfc522b99b7f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/features_check_mark.png
// module id = XV4b
// module chunks = 5